import { useEffect, useState } from "react";
import { Copy, Users, Gift, TrendingUp, Share2 } from "lucide-react";
import { toast } from "sonner";
import api, { fmtTL } from "@/lib/api";

export default function Affiliate() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/affiliate").then(({ data }) => setD(data)); }, []);
  if (!d) return <div className="py-10 text-center text-panel-muted">Yükleniyor...</div>;

  return (
    <div>
      <h1 className="font-head text-3xl font-bold tracking-tight">Ortaklık Programı</h1>
      <p className="text-panel-secondary text-sm mt-1 mb-5">Arkadaşlarını davet et, her yüklemelerinden <strong className="text-brand-500">%{d.percent}</strong> komisyon kazan.</p>

      <div className="grid grid-cols-2 gap-3 mb-5">
        <div className="card p-5"><Users className="text-brand-500 mb-2" size={22} /><div className="font-head text-2xl font-extrabold">{d.referrals}</div><div className="text-xs text-panel-muted">Davet Edilen</div></div>
        <div className="card p-5"><TrendingUp className="text-emerald-500 mb-2" size={22} /><div className="font-head text-2xl font-extrabold">{fmtTL(d.earnings)}</div><div className="text-xs text-panel-muted">Toplam Kazanç</div></div>
      </div>

      <div className="card p-5">
        <div className="flex items-center gap-2 mb-3"><Gift className="text-brand-500" size={18} /><h3 className="font-head font-semibold">Davet Linkin</h3></div>
        <div className="rounded-xl bg-panel-input border border-panel-border p-3 flex items-center justify-between gap-2">
          <span className="text-sm font-mono truncate" data-testid="affiliate-link">{d.link}</span>
          <button onClick={() => { navigator.clipboard.writeText(d.link); toast.success("Link kopyalandı"); }} className="text-brand-500 shrink-0"><Copy size={18} /></button>
        </div>
        <div className="mt-3 flex items-center gap-2">
          <div className="rounded-lg bg-brand/10 text-brand-500 px-3 py-2 text-sm font-semibold">Kod: {d.ref_code}</div>
          <button onClick={() => { if (navigator.share) navigator.share({ title: "smsonay.site", url: d.link }); else { navigator.clipboard.writeText(d.link); toast.success("Kopyalandı"); } }}
            className="btn-blue rounded-lg px-4 py-2 text-sm font-semibold flex items-center gap-2"><Share2 size={15} /> Paylaş</button>
        </div>
      </div>

      <div className="card p-5 mt-4">
        <h3 className="font-head font-semibold mb-2">Nasıl Çalışır?</h3>
        <ol className="text-sm text-panel-secondary space-y-2 list-decimal pl-5">
          <li>Davet linkini arkadaşlarınla paylaş.</li>
          <li>Onlar bu link ile kayıt olsun.</li>
          <li>Her bakiye yüklemelerinde %{d.percent} komisyon bakiyene eklenir.</li>
        </ol>
      </div>
    </div>
  );
}
